export * from "./modal-2";
export * from "./modal-2.component";
